import { ICommonPopupsProps } from '@gem/popups';

export interface IMyProfilePopupParams {
  hasBackButton?: boolean;
}

interface IMyProfilePopupPresenter {
  onBack(): void;
}

export const useMyProfilePopupPresenter = ({
  params = {},
  onBack,
  popupInstance,
}: ICommonPopupsProps<IMyProfilePopupParams>): IMyProfilePopupPresenter => {
  return {
    onBack(): void {
      if (!params.hasBackButton) {
        return;
      }

      popupInstance.close();
      onBack?.();
    },
  };
};
